<template>
    <div id="app">
      <div class="top-menu">

        <sporte-menu />
        <el-row v-if="user.authenticated" class="menu bottom-menu">
          <subheader></subheader>
        </el-row>
      </div>

      <el-row>
        <el-col :span="22" :offset="1" class="view-container">
          <router-view></router-view>
        </el-col>
      </el-row>
    </div>
</template>


<script>
  import subheader from './components/SubHeader.vue';
  import Menu from './components/Menu.vue'
  import auth from './auth/index';
  export default {
    name: 'app',
    methods: {
      changeRoute(route) {
        if(!route){
          return;
        }
        this.value = '';
        if(route === "logout"){
          this.logout();
        } else{
          this.$router.push({path:'/' + route});
        }
      },
      logout(){
        this.profile.name = '';
        auth.logout(this);
      },
      loadJS(url, callback) {
        jQuery.ajax({
          url: url,
          dataType: 'script',
          success: callback,
          async: true
        });
    },
    },
    data() {
      return {
        options: [
          {value: 'logout', label: 'Logout'},
          {value: 'profile', label: 'Profile'},
        ],
        value: '',
        user: auth.user,
        profile:{
          name: '',
        },
        showReportNav: false,
        innerWidth: 0,
        availableLinks: [],
        profileLinks: [
          {index: 1, label: "Logout", path: "/logout"},
          {index: 2, label: "Profile", path: "/profile"}
        ],
      }
    },
    beforeMount(){
      var profile = JSON.parse(auth.getProfile());
      
      if(profile){
        this.profile.name = profile.username;

        if(profile.role == 3) {
          this.options.push({value: 'admin/settings', label: 'Settings'})
        }
        
      }
    },
    mounted(){
      console.log(this.$router.history.current.path);

      this.innerWidth = window.innerWidth;

      this.loadJS('https://js.stripe.com/v3/', () => {
        // console.log('loaded Stripe');
      });
      this.loadJS('https://www.paypalobjects.com/api/checkout.js', () => {
        // console.log('loaded PayPal');
      });
    },
    components:{
      'subheader':subheader,
      SporteMenu: Menu
    }

  }
    
</script>

<style>
  
  body{
    font-family: "Arial";
    font-size: 12px;
    background-color: #F3F3F5;
    margin: 0;
    padding: 0;
  }
  
  .panelheader {
    margin-top: 4em;
    margin-bottom: 0.2em;
    width: 100%;
    height: 4em;
    background-color:white;
    border-top: 2.5px solid #29A9C0;
  }
  
  .panelheader .title {
    text-align: left;
    padding-left: 2em;
    padding-top: 1.4em;
    font-weight: 600;
    width: 50%;
    float: left;
  }
  
  .link {
    float:right;
    text-decoration: none;
    color: black;
    display: block;
    font-weight: 600;
    -webkit-transition: color 0.4s;
    transition: color 0.4s;
    margin-top: 1.5em;
    cursor: pointer;
  }
  
  .dropdown-link {
    text-decoration: none;
    color: black;
    font-weight: 400;
    display:block;
  }
  
  .link:hover {
    color: #52BCBA;
  }
  
  .dropdown {
    width: 100%;
  }
  
  .menu {
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    background: white;
  }
  
  .bottom-menu {
    margin-top: 0.2em;
  }
  .view-container {
    text-align: center;
    padding-bottom: 2em;
  }
  
  .router-link-exact-active {
    color: #52BCBA;
  }
  
  .profile-list {
    margin-top: 0.5em;
    border-left: 1px solid #EAEAEA;
    display: block;
    height: 4em;
  }
  
  .profile-list .el-select {
    float:right;
    width:80%;
  }
  
  .profile-list .el-input {
    font-size:11px;
  }
  
  .profile-list .el-input input {
    border: none !important;
  }
  
  .logo {
    margin-top:0.5em;
  }

  .logo img {
    height: 4em;
  }

  .hidden {
    display:none;
  }
  
  .border-1 {
    border-top-color: #33B0AE
  }
  
  .border-2 {
    border-top-color: #79CAC9
  }
  
  .border-3 {
    border-top-color: #147E9A
  }
  
  .border-4 {
    border-top-color: #F6A623
  }
  
  .clear {
    clear: both;
  }

 /* Delete and Edit buttons */
  .custom-actions, .sm-col {
    width: 110pt;
  }
  
  .edit-btn, .del-btn, .more-btn, .confirm-btn {
    color: white !important;
    padding: 5pt !important;
  }
  
  .more-btn {
    background-color: blueviolet !important;
  }

  .light-btn {
    background-color: yellow !important;
    padding: 6pt !important;
  }

  .edit-btn {
    background-color: #FEAC0E !important;
  }

  .confirm-btn {
    background-color: #00DD80 !important;
  }
  
  .del-btn {
    background-color: red !important;
  }


  /* Save/Cancel/Add buttons */
  .el-button--save, .el-button--save:focus {
    background: #147E9A;
    color: white;
    border-color: #c4c4c4;        
  }

  .el-button--save:hover {
    background: white;
    color: #147E9A;
    border-color: #147E9A;
  }

  .el-button--cancel {
    background: #9B9B9B;
    color: white;   
  }

  .el-button--cancel:hover {
    background: white;
    color: #9B9B9B;
    border-color: #9B9B9B;
  }

  .el-button--add, .el-button--add:focus {
    background: #33B0AE;
    color: white;
    border-color: #c4c4c4;    
  }

  .el-button--add:hover {
    background: white;
    color: #33B0AE;
    border-color: #33B0AE;
  }

  .btn-wrapper {
    margin-top: 4pt;
    float: right;
    width: 20%;
    text-align: right;
    margin-right: 10pt;
  }
  
  .left-nav {
    position: fixed;
    z-index: 100;
  }

  
  .left-nav ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    width: 110pt;
  }

  .left-nav li a {
      display: block;
      color: #666666;
      padding: 10pt 12pt;
      text-decoration: none;
      width: 110pt;
  }

  .left-nav li a:hover {
      background-color: #01809E !important;
      color: white !important;
  }
  
  .left-nav li {
    margin: 0.5pt;
    background-color: white;
    border: 1px solid #F2F2F2;
    
  }

  .el-form .el-select, .el-form .el-input-number {
    float: left;
  }

  .el-input-number + .el-slider__runway {
    margin-left: 150px;
  }

</style>



// WEBPACK FOOTER //
// App.vue?7d00aec8